import { useMutation } from '@tanstack/react-query';

import { createConversation } from './api';

/**
 * 대화 생성 useMutation hook
 */
export const useCreateConversation = () => {
  return useMutation({
    mutationFn: createConversation,
  });
};
